import { FieldErrorOrUndefined } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { BoxProps, Field, FieldErrorText } from "shared/components/Spor";

type FieldProps = Omit<BoxProps, "direction" | "gap">; // Everything except for direction is allowed for styling
export const FieldErrorMessage = ({
  field,
  ...rest
}: {
  field: FieldErrorOrUndefined;
} & FieldProps) => (
  <Field {...rest} invalid={!!field} data-testid="form-control-error-msg">
    <FieldErrorText>{field?.message}</FieldErrorText>
  </Field>
);
